// @flow
export const dataKey: 'kits' = 'kits';
